import React from 'react'
import { cx } from '@emotion/css'

type AddMemberRowProps<T> = {
  canBeAdded: boolean
  member: T
  addEntity: (member: T) => void
}

export function AddMemberRow<T>({
  children,
  addEntity,
  canBeAdded,
  member
}: React.PropsWithChildren<AddMemberRowProps<T>>) {
  return (
    <div
      className={cx('MembersSelector__member', {
        'no-click': !canBeAdded
      })}
      onClick={canBeAdded ? () => addEntity(member) : undefined}
    >
      {children}
    </div>
  )
}
